import React, { useContext } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import RootContext from '@/RootContext';



const stripSearch = search => {
	const queryParams = new URLSearchParams(search);
	queryParams.delete('tab');
	return queryParams.toString();
};

export default ({ children, className = '', isHeader = true, isSticky = true, path = '', noLinks }) => {
	const rootContext = useContext(RootContext);
	const auth = rootContext.get('auth');
	const location = useLocation();
	const navigate = useNavigate();

	const makeNavLink = ({ label, to }) => {
		const pathname = location.pathname.replace(/\/+$/, '').replace(/^\//, '');
		const parts = pathname.split('/');
		const to_pathname = typeof to === 'object' ? to.pathname : to;
		const active = parts.indexOf(to_pathname) !== -1 ? 'active' : '';
		return (<Link className={`nav-link ${active}`} to={path + to_pathname}  style={{ textDecoration: 'none' }}><span>{label}</span></Link>);
	};

	const handleSignOut = event => {
		event.preventDefault();
		signOut().catch(() => {});
	};
	
	return (
		<div className={`container-fluid px-0 bg-white ${isSticky ? 'sticky-top' : ''}`} style={{boxShadow: '0 0 10px 10px white'}}>
			{isHeader &&
				<div className={`navbar navbar-expand t py-0 px-0 app-navbar ${className}`} style={{  backgroundColor: "#fff" }}>
					<div className="container-fluid px-0">
						<div className="row w-100 mx-0 px-0 align-items-center">
							{auth ? (
								<>
									{noLinks ? undefined : (
										<div className="col-auto">
											<ul className="navbar-nav me-auto mb-2 mb-lg-0">
												{/* <li className="nav-item me-3">
													{makeNavLink({ label: 'Campaigns', to: { pathname: 'campaigns', search: stripSearch(location.search) } })}
												</li> */}
												<li className="nav-item me-3">
													{makeNavLink({ label: 'Studies', to: { pathname: 'studies' } })}
												</li>
												<li className="nav-item me-3">
													{makeNavLink({ label: 'Protocols', to: { pathname: 'protocols' } })}
												</li>
												<li className="nav-item me-3">
													{makeNavLink({ label: 'Segments', to: { pathname: 'segments', search: stripSearch(location.search) } })}
												</li>
												<li className="nav-item me-3">
													{makeNavLink({ label: 'Sites', to: { pathname: 'sites' } })}
												</li>
												<li className="nav-item me-3">
													{makeNavLink({ label: 'Recruitment Sources', to: { pathname: 'recruitment_sources' } })}
												</li>
												<li className="nav-item me-3">
													{makeNavLink({ label: 'Deals', to: { pathname: 'deals' } })}
												</li>
												<li className="nav-item me-3">
													{makeNavLink({ label: 'Workflows', to: { pathname: 'workflows' } })}
												</li>
												<li className="nav-item me-3">
													{makeNavLink({ label: 'Questionnaires', to: { pathname: 'questionnaires' } })}
												</li>
												{auth?.groups?.includes('admin') && (
													<li className="nav-item">
														{makeNavLink({ label: 'Agent Settings', to: { pathname: 'agent_settings' } })}
													</li>
												)}
												{/* <li className="nav-item">
													{makeNavLink({ label: 'Waitlists', to: { pathname: 'waitlists' } })}
												</li> */}
												{/* <li className="nav-item me-3">
													{makeNavLink({ label: 'Reporting', to: { pathname: 'reporting', search: stripSearch(location.search) } })}
												</li> */}
											</ul>
										</div>
									)}
								</>
							) : undefined}
							<div className="col-auto ms-auto">
								<ul className="navbar-nav me-auto mb-2 mb-lg-0">
									{!auth && (
										<>
											<li className="nav-item me-3">
												{makeNavLink({ label: 'Join', to: { pathname: 'join' } })}
											</li>
											<li className="nav-item">
												{makeNavLink({ label: 'Sign in', to: { pathname: '/sign_in' } })}
											</li>
										</>
									)}
								</ul>
							</div>
						</div>
					</div>
				</div>
			}
			{children}
		</div>
	);
};
